/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Today_Pending_SyncInputs */

const en_us2_today_pending_sync = /** @type {(inputs: Today_Pending_SyncInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 change waiting to sync`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 change waiting to sync`);
	return /** @type {LocalizedString} */ (`${i?.count} changes waiting to sync`)
	
};

const pt_br2_today_pending_sync = /** @type {(inputs: Today_Pending_SyncInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 alteração aguardando sincronização`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 alteração aguardando sincronização`);
	return /** @type {LocalizedString} */ (`${i?.count} alterações aguardando sincronização`)
	
};

const es_419_today_pending_sync = /** @type {(inputs: Today_Pending_SyncInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 cambio pendiente de sincronizar`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 cambio pendiente de sincronizar`);
	return /** @type {LocalizedString} */ (`${i?.count} cambios pendientes de sincronizar`)
	
};

const pt_pt2_today_pending_sync = /** @type {(inputs: Today_Pending_SyncInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 alteração à espera de sincronização`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 alteração à espera de sincronização`);
	return /** @type {LocalizedString} */ (`${i?.count} alterações à espera de sincronização`)
	
};

const fr_fr2_today_pending_sync = /** @type {(inputs: Today_Pending_SyncInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 modification en attente de synchro`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 modification en attente de synchro`);
	return /** @type {LocalizedString} */ (`${i?.count} modifications en attente de synchro`)
	
};

const de_de2_today_pending_sync = /** @type {(inputs: Today_Pending_SyncInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Änderung wartet auf Synchronisierung`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Änderung wartet auf Synchronisierung`);
	return /** @type {LocalizedString} */ (`${i?.count} Änderungen warten auf Synchronisierung`)
	
};

const it_it2_today_pending_sync = /** @type {(inputs: Today_Pending_SyncInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 modifica in attesa di sincronizzazione`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 modifica in attesa di sincronizzazione`);
	return /** @type {LocalizedString} */ (`${i?.count} modifiche in attesa di sincronizzazione`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 change waiting to sync" |
* | "-1" | "1 change waiting to sync" |
* | * | "{count} changes waiting to sync" |
*
* @param {Today_Pending_SyncInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_pending_sync = /** @type {((inputs: Today_Pending_SyncInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Pending_SyncInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_pending_sync(inputs)
	if (locale === "es-419") return es_419_today_pending_sync(inputs)
	if (locale === "pt-PT") return pt_pt2_today_pending_sync(inputs)
	if (locale === "fr-FR") return fr_fr2_today_pending_sync(inputs)
	if (locale === "de-DE") return de_de2_today_pending_sync(inputs)
	if (locale === "it-IT") return it_it2_today_pending_sync(inputs)
	return en_us2_today_pending_sync(inputs)
});
export { today_pending_sync as "today.pending_sync" }